import { WorkInProgress } from '@/components/WorkInProgress';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/group')({
	component: RouteComponent,
	beforeLoad: () => ({ crumb: 'Group' }),
});

function RouteComponent() {
	return <WorkInProgress />;
}
